// Ticket Variants Premium JavaScript
document.addEventListener('DOMContentLoaded', function() {
  // Get translations from data attributes
  const script = document.querySelector('script[src*="ticket-variants-premium.js"]');
  const translations = {
    ticketAddedSuccess: script?.dataset?.ticketAddedSuccess || 'Ticket added to cart successfully!',
    addingToCart: script?.dataset?.addingToCart || 'Adding...',
    addedToCart: script?.dataset?.addedToCart || 'Added!'
  };
  // Initialize all ticket cards
  const ticketCards = document.querySelectorAll('.ticket-variant-card');
  
  ticketCards.forEach(card => {
    const variantId = card.dataset.variantId;
    const decreaseBtn = card.querySelector('.qty-decrease');
    const increaseBtn = card.querySelector('.qty-increase');
    const qtyInput = card.querySelector('.qty-input');
    const addToCartBtn = card.querySelector('.add-to-cart-btn');
    
    // Quantity controls
    if (decreaseBtn && increaseBtn && qtyInput) {
      decreaseBtn.addEventListener('click', () => {
        const currentVal = parseInt(qtyInput.value);
        if (currentVal > 1) {
          qtyInput.value = currentVal - 1;
        }
      });
      
      increaseBtn.addEventListener('click', () => {
        const currentVal = parseInt(qtyInput.value);
        const maxVal = parseInt(qtyInput.max);
        if (currentVal < maxVal) {
          qtyInput.value = currentVal + 1;
        }
      });
      
      // Prevent manual input of invalid values
      qtyInput.addEventListener('change', () => {
        const val = parseInt(qtyInput.value);
        const maxVal = parseInt(qtyInput.max);
        const minVal = parseInt(qtyInput.min);
        
        if (isNaN(val) || val < minVal) {
          qtyInput.value = minVal;
        } else if (val > maxVal) {
          qtyInput.value = maxVal;
        }
      });
    }
    
    // Add to cart functionality
    if (addToCartBtn) {
      addToCartBtn.addEventListener('click', async function() {
        const quantity = parseInt(qtyInput.value);
        const productId = this.dataset.productId;
        
        // Add loading state
        this.classList.add('loading');
        this.disabled = true;
        const originalText = this.innerHTML;
        this.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor" class="animate-spin"><path d="M12 2v4m0 12v4m10-10h-4M6 12H2"/></svg> ' + translations.addingToCart;
        
        try {
          // Add to cart via Shopify AJAX API
          const formData = {
            'items': [{
              'id': variantId,
              'quantity': quantity
            }]
          };
          
          const response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify(formData)
          });
          
          if (response.ok) {
            const data = await response.json();
            
            // Success animation
            this.classList.remove('loading');
            this.classList.add('success');
            this.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/></svg> ' + translations.addedToCart;
            
            // Update cart count if element exists
            updateCartCount();
            
            // Show success notification
            showNotification(translations.ticketAddedSuccess, 'success');
            
            // Reset button after delay
            setTimeout(() => {
              this.classList.remove('success');
              this.innerHTML = originalText;
              this.disabled = false;
              qtyInput.value = 1;
            }, 2000);
            
          } else {
            throw new Error('Failed to add to cart');
          }
        } catch (error) {
          console.error('Error adding to cart:', error);
          
          // Error state
          this.classList.remove('loading');
          this.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/></svg> Error';
          
          showNotification('Failed to add ticket to cart. Please try again.', 'error');
          
          setTimeout(() => {
            this.innerHTML = originalText;
            this.disabled = false;
          }, 2000);
        }
      });
    }
  });
  
  // Update cart count
  async function updateCartCount() {
    try {
      const response = await fetch('/cart.js');
      const cart = await response.json();
      
      // Update cart count in header - target the cart-count custom element
      const cartCountElement = document.querySelector('cart-count');
      if (cartCountElement) {
        // Update the visible count
        const countSpan = cartCountElement.querySelector('span[aria-hidden="true"]');
        if (countSpan) {
          countSpan.textContent = cart.item_count;
        }
        
        // Update screen reader text
        const srSpan = cartCountElement.querySelector('.sr-only');
        if (srSpan) {
          srSpan.textContent = srSpan.textContent.replace(/\d+/, cart.item_count);
        }
        
        // Show/hide the count bubble based on item count
        if (cart.item_count > 0) {
          cartCountElement.classList.remove('opacity-0');
        } else {
          cartCountElement.classList.add('opacity-0');
        }
      }
      
      // Also update any elements with data-cart-count attribute (for compatibility)
      const cartCountElements = document.querySelectorAll('[data-cart-count]');
      cartCountElements.forEach(el => {
        el.textContent = cart.item_count;
      });
      
      // Update cart drawer if it exists
      if (typeof updateCartDrawer === 'function') {
        updateCartDrawer();
      }
    } catch (error) {
      console.error('Error updating cart count:', error);
    }
  }
  
  // Show notification
  function showNotification(message, type = 'info') {
    // Remove existing notifications
    const existingNotification = document.querySelector('.ticket-notification');
    if (existingNotification) {
      existingNotification.remove();
    }
    
    // Create notification element
    const notification = document.createElement('div');
    notification.className = `ticket-notification ticket-notification--${type}`;
    notification.innerHTML = `
      <div class="notification-content">
        ${type === 'success' ? '<svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor"><path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/></svg>' : ''}
        ${type === 'error' ? '<svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor"><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z"/></svg>' : ''}
        <span>${message}</span>
      </div>
    `;
    
    // Add styles
    const styles = `
      <style>
        .ticket-notification {
          position: fixed;
          top: 20px;
          right: 20px;
          z-index: 9999;
          padding: 1rem 1.5rem;
          border-radius: 8px;
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
          animation: slideIn 0.3s ease;
          max-width: 400px;
        }
        
        .ticket-notification--success {
          background: #10B981;
          color: white;
        }
        
        .ticket-notification--error {
          background: #EF4444;
          color: white;
        }
        
        .ticket-notification--info {
          background: #3B82F6;
          color: white;
        }
        
        .notification-content {
          display: flex;
          align-items: center;
          gap: 0.75rem;
        }
        
        @keyframes slideIn {
          from {
            transform: translateX(100%);
            opacity: 0;
          }
          to {
            transform: translateX(0);
            opacity: 1;
          }
        }
        
        @keyframes slideOut {
          from {
            transform: translateX(0);
            opacity: 1;
          }
          to {
            transform: translateX(100%);
            opacity: 0;
          }
        }
        
        .ticket-notification.removing {
          animation: slideOut 0.3s ease;
        }
      </style>
    `;
    
    // Add styles if not already added
    if (!document.querySelector('#ticket-notification-styles')) {
      const styleElement = document.createElement('div');
      styleElement.id = 'ticket-notification-styles';
      styleElement.innerHTML = styles;
      document.head.appendChild(styleElement);
    }
    
    // Add to page
    document.body.appendChild(notification);
    
    // Auto remove after 5 seconds
    setTimeout(() => {
      notification.classList.add('removing');
      setTimeout(() => {
        notification.remove();
      }, 300);
    }, 5000);
  }
  
  // Add hover effects for cards
  ticketCards.forEach(card => {
    card.addEventListener('mouseenter', function() {
      this.style.transform = 'translateY(-4px)';
    });
    
    card.addEventListener('mouseleave', function() {
      this.style.transform = 'translateY(0)';
    });
  });
  
  // Animate availability badges on load
  const availabilityBadges = document.querySelectorAll('.availability-badge');
  availabilityBadges.forEach((badge, index) => {
    badge.style.animation = `fadeIn 0.5s ease ${index * 0.1}s both`;
  });
  
  // Add fade in animation style
  const fadeInStyle = document.createElement('style');
  fadeInStyle.textContent = `
    @keyframes fadeIn {
      from {
        opacity: 0;
        transform: translateY(-10px);
      }
      to {
        opacity: 1;
        transform: translateY(0);
      }
    }
    
    @keyframes spin {
      from {
        transform: rotate(0deg);
      }
      to {
        transform: rotate(360deg);
      }
    }
    
    .animate-spin {
      animation: spin 1s linear infinite;
    }
  `;
  document.head.appendChild(fadeInStyle);
  
  // Track user interactions for analytics
  ticketCards.forEach(card => {
    const variantId = card.dataset.variantId;
    
    card.addEventListener('click', function(e) {
      // Don't track if clicking on buttons
      if (e.target.closest('button') || e.target.closest('input')) return;
      
      // Track card view
      if (typeof gtag !== 'undefined') {
        gtag('event', 'view_item', {
          'currency': 'USD',
          'value': parseFloat(card.querySelector('.price-value').textContent),
          'items': [{
            'item_id': variantId,
            'item_name': card.querySelector('.ticket-title').textContent.trim(),
            'item_category': card.querySelector('.category-label').textContent.trim(),
            'quantity': 1
          }]
        });
      }
    });
  });
});